export const GOOGLE_RATING = "5.0";
export const GOOGLE_REVIEW_COUNT = 6;

export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/?cid=9418872304596581396";

export const GOOGLE_WRITE_REVIEW_URL =
  "https://www.google.com/search?q=Jakin+Creative+Design+%26+Marketing&ludocid=9418872304596581396#lrd=0x6611d9acf1c2b9f9:0x82b68e752c3e7c14,3";

export const REVIEWS = [
  {
    name: "Martha Gonzalez",
    text: "Stefanie is great to work with! She is patient, kind, she listens to your business needs and thinks quickly to come up with creative solutions.",
  },
  {
    name: "Michele J. D'Ambrosio",
    text: "Working on projects with Jakin is effective and timely. We met today, made a reel and took photos. Then we created a Google profile for my business, Michele D'Ambrosio Better Life Coaching. Afterwards we wrote a weekly timeline. Simple — in one take she has an eye, and listens to your request and business needs. I recommend Stephanie and her creative design.",
  },
  {
    name: "Sandra Smith",
    text: "Stefanie did an outstanding job on a PowerPoint presentation for the Town of Longboat Key for our insurance agency.",
  },
  {
    name: "Ana D.",
    text: "Stefanie makes you feel super comfortable with taking pictures and is very passionate with what she does. I highly recommend her.",
  },
  {
    name: "Cameron DeBruin",
    text: "Stephanie did some great work for my business Longboat Key Limo and Taxi. A wonderful flyer and email campaign.",
  },
  {
    name: "Andy Adamczyk",
    text: "Pleasure to deal with Stephanie.",
  },
];
